export default __webpack_public_path__ + "static/media/p4.c53599c6.jpg";